export default "__VITE_ASSET__5c351dc3__"